import { api } from "@service/api";
import { useEffect, useState } from "react";
import { Card } from "@components/cards/card";
import { RaffleDefaultNumberRewards } from "@components/raffles/default/number/rewards";
import { IRaffleDefaultRewardDTO } from "@hooks/dtos/raffles/IRaffleDefaultDTO";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import Skeleton from "react-loading-skeleton";

interface IProps {
  raffleKey: string;
  campaign?: string;
}

interface IShow {
  reward: boolean;
}

interface ILoading {
  reward: boolean;
}

export const RaffleRewardVisitor = ({ raffleKey, campaign }: IProps) => {
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  const [show, setShow] = useState<IShow>({
    reward: false,
  });
  const [isLoading, setIsLoading] = useState<ILoading>({
    reward: true,
  });

  const [rewards, setRewards] = useState<IRaffleDefaultRewardDTO[]>([]);

  async function loadRaffleRewards() {
    try {
      setIsLoading((prev) => ({
        ...prev,
        reward: true,
      }));

      const params = `?campaign=${campaign}&key=${raffleKey}`;
      const response = await api.get(
        `/customer/raffle/default/rewards${params}`,
      );

      const _rewardTotal: number = response.data.reduce(
        (acc: number, reward: IRaffleDefaultRewardDTO) => {
          return acc + (Number(reward.price) || 0);
        },
        0,
      );

      setRewards(response.data);

      setIsLoading((prev) => ({
        ...prev,
        reward: false,
      }));
    } catch (error: any) {
      pushToastify({
        message:
          error?.response?.data?.message ||
          "Falha ao carregar as informações do(s) prêmio(s).",
        type: "error",
        theme: "dark",
      });
    }
  }

  useEffect(() => {
    loadRaffleRewards();
  }, []);

  return (
    <>
      <Card>
        <div className="card-header">
          <div className="text-center">
            <div className="card-title">
              Prêmio{rewards && rewards?.length > 1 ? `s` : ``} da Campanha
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="row mb-1">
            <div className="col-md-12 text-center">
              <div className="col-md-2 mx-auto border rounded-4 py-1 mb-2">
                <span
                  className="fw-bold"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow((prev) => ({
                      ...prev,
                      reward: !show.reward,
                    }))
                  }
                >
                  {show.reward ? `Ocultar` : `Mostrar`} Premiaç
                  {rewards && rewards?.length > 1 ? `ões` : `ão`}
                </span>
              </div>
              <div className={`${show.reward ? `` : `d-none`} mt-4`}>
                {isLoading.reward ? (
                  <>
                    <Skeleton count={2} />
                  </>
                ) : (
                  <>{<RaffleDefaultNumberRewards rewards={rewards || []} />}</>
                )}
              </div>
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};
